import { WithDestroy } from 'src/app/shared/utils/mixins/withDestroy';
import { extend } from 'underscore';
import { Component, inject, Input, OnInit } from '@angular/core';
import { CustomisedMultiSelectComponent, ISelectorOption } from "../../../../shared/components/customised-multi-select/customised-multi-select.component";
import { IShortcutFilter } from 'src/app/services/shortcut.service';
import { BroadcastService } from 'src/app/services/broadcast.service';
import { PerformanceReviewService } from 'src/app/services/performance-review.service';
import { takeUntil } from 'rxjs/operators';
import { NgIf } from '@angular/common';

@Component({
  selector: "app-cycles-selector",
  imports: [CustomisedMultiSelectComponent, NgIf],
  templateUrl: "./cycles-selector.component.html",
  styleUrl: "./cycles-selector.component.scss",
})
export class CyclesSelectorComponent extends WithDestroy() implements OnInit {

  private performanceReviewService = inject(PerformanceReviewService);
  private broadcastService = inject(BroadcastService);
  @Input() controls;
  @Input() submitted;

  @Input() hasTitle = true;
  @Input() title = "Cycles";
  @Input() controlName = "cycles";
  @Input() placeholder = "Select Cycles";
  @Input() displayName = "cycle";
  @Input() width = 200;
  @Input() initValues?;
  @Input() borderFirstItem = false;
  @Input() prefilter: string[];
  @Input() autoGrow = true;
  @Input() showNumOnSelectAll = true;
  @Input() defaultAllSelected = false;
  @Input() allPreFilters: Partial<IShortcutFilter>; // if passing all shortcut values
  options: ISelectorOption[];


  savedFilter$ = this.broadcastService.on("saved-filter-applied");

  constructor(
  ) {
    super();
  }

  ngOnInit(): void {
    this.submitted = false;
    this.performanceReviewService.fetchCacheCycleConfigsWithExtrasFiltered().pipe(takeUntil(this.destroy$))
    .subscribe(res => {
      this.options = res.filter(cycle => cycle.config.status === 'Active').map(c => ({
        label: c?.config?.title,
        value: c?.config?.cycleConfigID
      }));
      if(this.initValues){
        this.controls.cycles.setValue(this.initValues);
      } else {
        this.controls.cycles.setValue(this.options.map(o => o.value));
      }
      this.submitted = true;
    })

  }


}
